import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ActionBarItem } from '@model/action-bar-item.model';
declare var $:any;

@Component({
  selector: 'app-action-bar',
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.scss']
})
export class ActionBarComponent implements OnInit {
  @Output() actionChange = new EventEmitter();
  @Input() actions: Array<ActionBarItem> = new Array(0);
  @Input() validateStatus = false;
  @Input() disabled = false;
  selected: string;
  open: boolean;
  ActionItem = false;

  constructor() { }

  ngOnInit() {
    try {
      $(() => {
        $('[data-toggle-second="tooltip"]').tooltip();
      });

    } catch (error) {

    }finally{
      // console.log('actions:', this.actions);

    }

  }

  onToggle($event: Event) {
    $event.stopPropagation();
    this.open = true;
  }
  selectAction(menuItem) {
    this.actionChange.emit(menuItem);
    this.open = false;
  }
  actionCheck(){
    this.ActionItem = false
    for(let item of this.actions){
      if(item.value){
        this.ActionItem = true;
      }
    }
  }
  getActiveActions() {
    return this.actions.filter(elt => elt.value == true)
  }
}
